import Otp from "../../../jsx/pages/Otp";

const LoginWrapper = function (props) {
  return <Otp />;
};

export default constore(LoginWrapper);
